// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"A_TheComp__cew4T"};